import { LeafMentionSuggestion, MentionSuggestion } from './MentionsList';

const buildLeaf = (slug: string, label: string, type = 'Short Text'): LeafMentionSuggestion => ({
  slug,
  label,
  type,
  available: true,
});

const buildSeedGroups = (childCount: number): MentionSuggestion[] => {
  const groups: Array<{ label: string; suggestions: LeafMentionSuggestion[] }> = [
    {
      label: "Let's do this!",
      suggestions: [
        buildLeaf('mock-seed-primary-email', 'Primary Email', 'Email'),
        buildLeaf('mock-seed-work-email', 'Work Email', 'Email'),
        buildLeaf('mock-seed-contact-email', 'Contact Email', 'Email'),
        buildLeaf('mock-seed-tiktok-handle', 'TikTok Handle'),
        buildLeaf('mock-seed-snapchat-handle', 'Snapchat Handle'),
        buildLeaf('mock-seed-pinterest', 'Pinterest'),
        buildLeaf('mock-seed-youtube-handle', 'YouTube Handle'),
      ],
    },
    {
      label: 'Personal details',
      suggestions: [
        buildLeaf('mock-seed-first-name', 'First Name'),
        buildLeaf('mock-seed-last-name', 'Last Name'),
        buildLeaf('mock-seed-personal-email', 'Personal Email', 'Email'),
        buildLeaf('mock-seed-phone-number', 'Phone Number', 'Phone'),
        buildLeaf('mock-seed-headshot', 'Headshot', 'File'),
      ],
    },
    {
      label: 'Team contacts',
      suggestions: [
        buildLeaf('mock-seed-booking-email', 'Booking Email', 'Email'),
        buildLeaf('mock-seed-manager-email', 'Manager Email', 'Email'),
        buildLeaf('mock-seed-agent-email', 'Agent Email', 'Email'),
        buildLeaf('mock-seed-instagram-handle', 'Instagram Handle'),
        buildLeaf('mock-seed-website', 'Website URL'),
      ],
    },
  ];

  return groups.map(group => ({
    label: group.label,
    available: true,
    suggestions: group.suggestions.slice(0, childCount),
  }));
};

export const buildMockMentions = (rootCount: number, childCount: number): MentionSuggestion[] => {
  const seedGroups = buildSeedGroups(childCount);

  if (rootCount <= seedGroups.length) {
    return seedGroups.slice(0, rootCount);
  }

  const rootSuggestions = [...seedGroups];

  for (let rootIndex = seedGroups.length + 1; rootIndex <= rootCount; rootIndex++) {
    const children: LeafMentionSuggestion[] = [];

    for (let childIndex = 1; childIndex <= childCount; childIndex++) {
      children.push({
        slug: `mock-${rootIndex}-field-${childIndex}`,
        label: `Mock field ${rootIndex}.${childIndex}`,
        type: childIndex % 4 === 0 ? 'Long Text' : childIndex % 3 === 0 ? 'Number' : 'Short Text',
        available: true,
      });
    }

    rootSuggestions.push({
      label: `Mock group ${rootIndex}`,
      available: true,
      suggestions: children,
    });
  }

  return rootSuggestions;
};
